const MIN_AGE_YEARS_THRESHOLD = 24

// Empty value -> "--". Below 24 months -> "X months". From 24 months onwards
// show it in years (e.g. 36 -> "3 years", 30 -> "2.5 years").
export function formatMinAge(value) {
    if (value === null || value === undefined || value === '') return '--'
    const months = Number(value)
    if (Number.isNaN(months)) return '--'
    if (months < MIN_AGE_YEARS_THRESHOLD) return `${months} months`
    const years = Math.round((months / 12) * 10) / 10
    return `${years} years`
}
